// Mock data for Louis Vuitton Second-Hand Shop

export const featuredProducts = [
  {
    id: 'r21',
    name: 'Louis Vuitton Ballerina',
    category: 'Shoes',
    price: 230,
    condition: 'Very Good',
    image: 'https://img.ricardostatic.ch/images/108b4e79-12cb-4f57-a670-d4cfb6514ebf/t_450/%E2%9D%A4-louis-vuitton-ballerina%E2%9D%A4%EF%B8%8F',
    featured: true
  },
  {
    id: 'r18',
    name: 'Louis Vuitton Schlüsseletui Monogramm Denim',
    category: 'Key Case',
    price: 499,
    condition: 'Very Good',
    image: 'https://img.ricardostatic.ch/images/06ff4b52-84d1-43e9-accd-cfd45f6fa225/t_450/%F0%9F%91%9C-%E2%9D%A4%EF%B8%8F-louis-vuitton-schluesseletui-monogramm-denim',
    featured: true
  },
  {
    id: 'r40',
    name: 'Louis Vuitton Zippy Coin Giant Jungle',
    category: 'Coin Purse',
    price: 599,
    condition: 'Very Good',
    image: 'https://img.ricardostatic.ch/images/76fb3ec2-b402-4124-a91b-3c4154772eb3/t_450/%E2%9D%A4%EF%B8%8F-louis-vuitton-zippy-coin-giant-jungle',
    featured: true
  },
  {
    id: 'r13',
    name: 'Louis Vuitton Reykjavik Schal',
    category: 'Scarf',
    price: 790,
    condition: 'Excellent',
    image: 'https://img.ricardostatic.ch/images/9f13d08e-92d8-4d89-b8cb-99c98661ac95/t_450/%F0%9F%8C%B9louis-vuitton-reykjavik-schal',
    featured: true
  }
];

export const testimonials = [
  {
    id: '1',
    name: 'Mombasaexpress',
    role: 'ricardo Bewertung',
    content: 'Ich bin total begeistert 😍 Die Tasche ist noch in einem besseren Zustand, als ich erwartet habe!! Top verpackt und turbo Lieferung. Diese Verkäuferin kann ich von ❤️ empfehlen 👍',
    rating: 5,
    avatar: 'M'
  },
  {
    id: '2',
    name: 'VanMatterh0rn',
    role: 'ricardo Bewertung',
    content: 'Sehr netter Kontakt und unkompliziert. Ich kann die Käuferin/Verkäufer(in) nur empfehlen :-)',
    rating: 5,
    avatar: 'V'
  },
  {
    id: '3',
    name: 'nat_qbq6',
    role: 'ricardo Bewertung',
    content: 'Der Artikel wie beschrieben, tolle Kommunikation und sehr schnelle Lieferung. Danke',
    rating: 5,
    avatar: 'N'
  }
];

export const howItWorks = [
  {
    step: '01',
    title: 'Browse Collection',
    description: 'Explore our curated selection of authenticated Louis Vuitton pieces, each with detailed condition reports and high-quality images.'
  },
  {
    step: '02',
    title: 'Authentication Guarantee',
    description: 'Every item undergoes rigorous authentication by luxury goods experts. We provide certificates of authenticity with each purchase.'
  },
  {
    step: '03',
    title: 'Secure Purchase',
    description: 'Enjoy secure checkout with buyer protection. We offer worldwide shipping with full insurance and elegant luxury packaging.'
  },
  {
    step: '04',
    title: 'Love Your Luxury',
    description: 'Receive your authenticated Louis Vuitton treasure. 14-day satisfaction guarantee with hassle-free returns if needed.'
  }
];

export const trustBadges = [
  { icon: 'Shield', text: '100% Authenticated' },
  { icon: 'Truck', text: 'Insured Shipping' },
  { icon: 'Award', text: 'Expert Curated' }
];

export const stats = [
  { value: '2000+', label: 'Pieces Sold' },
  { value: '99.7%', label: 'Satisfaction Rate', link: 'https://www.ricardo.ch/de/shop/Luxury_Limited/ratings/' },
  { value: '100%', label: 'Authenticated' }
];